window.HGW = window.HGW || {};

HGW.schedule = {
  buildSlots({ store, dateStr }) {
    if (!store?.pickup?.schedule) return [];

    const isoDate = dateStr;

    if (store.holiday?.pickup_disabled) {
      return [];
    }

    if (
      Array.isArray(store.holiday?.dates) &&
      store.holiday.dates.includes(isoDate)
    ) {
      return [];
    }

    const scheduleMap = store.pickup.schedule;

    const {
      toMinutes,
      minutesToTime,
      isToday,
      getWeekday
    } = HGW.utils;

    if (!dateStr) return [];

    const weekdayMap = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    const raw = getWeekday(dateStr);
    const weekday =
      typeof raw === "number"
        ? weekdayMap[raw]
        : String(raw).toLowerCase().slice(0, 3);

    const dayConfig = scheduleMap[weekday];
    if (!dayConfig || !dayConfig.open || !dayConfig.close) {
      return [];
    }

    const start = toMinutes(dayConfig.open);
    const end = toMinutes(dayConfig.close);
    const dur = Number(store.pickup.slot_duration) || 30;

    if (!Number.isFinite(start) || !Number.isFinite(end)) {
      return [];
    }

    const today = isToday(dateStr);
    const now = new Date();
    const nowMinutes = now.getHours() * 60 + now.getMinutes();

    const PREP_MINUTES = Number(store.pickup.cutoff_buffer_min) || 0;
    const ROUND_TO = 15;

    let minStartMinutes = null;

    if (today) {
      minStartMinutes =
        Math.ceil((nowMinutes + PREP_MINUTES) / ROUND_TO) * ROUND_TO;
    }

    const slots = [];

    for (let t = start; t + dur <= end; t += dur) {
      let disabled = false;

      if (
        today &&
        Number.isFinite(minStartMinutes) &&
        t < minStartMinutes
      ) {
        disabled = true;
      }

      slots.push({
        value: `${minutesToTime(t)} - ${minutesToTime(t + dur)}`,
        label: `${minutesToTime(t)} - ${minutesToTime(t + dur)}`,
        startMinutes: t,
        disabled
      });
    }

    return slots;
  }
};